'use strict';
(function () {
	angular
		.module('onboarding.common')
		.directive('cobSwitch', cobSwitch);

	cobSwitch.$inject = [];

	function cobSwitch() {

		return {
			restrict: 'E',
			scope: {
				model: '=ngModel',
				disabled: '=?ngDisabled',
				trueValue:  '=?',
				falseValue: '=?',
				change: '&?ngChange'
			},
			templateUrl: '/app/common/directives/cobSwitch.html',
			link: linkFunction
		};
	}

	function linkFunction(scope, element, attrs) {

		var defaultProperties = { trueValue: true, falseValue: false, disabled: false };
		var defaultAttributes = { trueLabel: 'On', falseLabel: 'Off' };

		activate();

		function activate() {
			angular.forEach(defaultProperties, function (value, key) {
				if (!angular.isDefined(scope[key]))
					scope[key] = value;
			});

			angular.forEach(defaultAttributes, function (value, key) {
				if (!angular.isDefined(scope[key]))
					attrs[key] = value;
			});

			scope.set = function (value) {
				if (scope.disabled || value == scope.shadowModel) return;
				if (angular.isFunction(scope.change))
					scope.change({ newValue: value, oldValue: scope.shadowModel });
				scope.shadowModel = value;
			};

			scope.onChange = function () {
				var oldValue = scope.model,
					newValue = scope.shadowModel ? scope.trueValue : scope.falseValue;

				scope.model = newValue;
				if (angular.isFunction(scope.change))
					scope.change({ newValue: newValue, oldValue: oldValue });
			};

			scope.$watch('model', function () {
				scope.shadowModel = scope.model == scope.trueValue;
			});

			scope.$watch('shadowModel', function () {
				scope.model = scope[scope.shadowModel + 'Value'];
			});
		}
	}
})();
